import { render, staticRenderFns } from "./DashboardUsuario.vue?vue&type=template&id=fe35823e&"
import script from "./DashboardUsuario.vue?vue&type=script&lang=js&"
export * from "./DashboardUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports